(function(){
  if(window.__scorePromo)return;window.__scorePromo=1;
  function ready(fn){if(document.readyState!=="loading")fn();else document.addEventListener("DOMContentLoaded",fn);}
  ready(function(){
    var el=document.getElementById("score-promo");if(!el)return;
    var KEY="scorePromoSeen_v1";
    var editor=window.Shopify&&window.Shopify.designMode;
    if(!editor){var last=0;try{last=parseInt(localStorage.getItem(KEY)||"0",10);}catch(e){}if(last&&(Date.now()-last)<72000000)return;}
    var html=document.documentElement;
    function open(){el.classList.add("is-open");html.style.overflow="hidden";}
    function close(){el.classList.remove("is-open");html.style.overflow="";try{localStorage.setItem(KEY,String(Date.now()));}catch(e){}}
    setTimeout(open,editor?300:1300);
    el.addEventListener("click",function(e){if(e.target.hasAttribute("data-close"))close();});
    document.addEventListener("keydown",function(e){if(e.key==="Escape"&&el.classList.contains("is-open"))close();});
  });
})();
